import { Component, OnInit, inject } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Column,
  DataTableComponent,
  EmptyTableComponent,
  NimmstaDataSource,
} from '@nimmsta/ng-commons-lib/data-table';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { StatusBadgePipe, TimePipe } from '@nimmsta/ng-commons-lib/pipes';
import { WorkflowService } from '@nimmsta/ng-commons-lib/services/workflow';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkflowExecution } from '../models/workflowExecution';
import { WorkflowExecutionService } from '../services/workflow-execution.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

_('workflow.execution.title');

@Component({
    selector: 'app-workflow-executions',
    templateUrl: './workflow-execution.component.html',
    imports: [TranslatePipe, DataTableComponent, HeaderBarComponent, EmptyTableComponent, ErrorComponent],
    providers: [TimePipe, StatusBadgePipe],
})
export class WorkflowExecutionComponent implements OnInit {
  private service = inject(WorkflowExecutionService);
  private timePipe = inject(TimePipe);
  private statusBadge = inject(StatusBadgePipe);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private workflowService = inject(WorkflowService);
  private router = inject(Router);

  source!: NimmstaDataSource<WorkflowExecution>;

  error?: HttpErrorResponse;

  workflowId?: string;

  title = this.translate.instant('workflow.execution.title');

  get columns(): Column[] {
    return [
      new Column('lastUpdatedAt', 'date', { pipe: this.timePipe }),
      new Column('jobName', 'job.singular'),
      new Column('workerName', 'worker.singular'),
      new Column('handheldName', 'mdm.singular'),
      new Column('status', 'workflow.status', { pipe: this.statusBadge }),
    ];
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.workflowId = params.get('workflow_id')!;
      this.service.currentWorkflowId = this.workflowId;
      this.source = new NimmstaDataSource<WorkflowExecution>(this.service);
    });
    this.workflowService.get(this.workflowId!).subscribe((workflow) => {
      this.title += ' - ' + workflow.name;
    });
  }

  show(id: string): void {
    this.router.navigate(['/workflows', this.workflowId, 'executions', id]);
  }
}
